import { render, staticRenderFns } from "./customerSalesExpenseBudgetRD.vue?vue&type=template&id=4f15928e&scoped=true&"
import script from "./customerSalesExpenseBudgetRD.vue?vue&type=script&lang=js&"
export * from "./customerSalesExpenseBudgetRD.vue?vue&type=script&lang=js&"
import style0 from "./customerSalesExpenseBudgetRD.vue?vue&type=style&index=0&id=4f15928e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f15928e",
  null
  
)

export default component.exports